// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2gYbD","approved":"Status_approved__3gkOH","rejected":"Status_rejected__3fWxs","expired":"Status_expired__2QR2l","label":"Status_label__1bWY3"};